import { Banner } from '@weareopenr/component-library';
import { useEffect, useState } from 'react';
import { BANNER_MONTH_EXPIRY_TIME, BANNER_COOKIE_NAME } from 'src/constants';

export interface IBanner {
  text: string;
  storageKey?: string;
}

const WarningBanner = ({ text, storageKey }: IBanner) => {
  const COOKIE = storageKey || BANNER_COOKIE_NAME;
  const [hideBanner, setHideBanner] = useState<boolean>(shouldShowBanner(COOKIE));

  const closeBanner = () => {
    const todaysDate: Date = new Date();
    todaysDate.setMonth(todaysDate.getMonth() + BANNER_MONTH_EXPIRY_TIME);
    document.cookie = `${COOKIE}=true; expires=${todaysDate.toUTCString()};`;
    setHideBanner(true);
  };

  useEffect(() => {
    let intervalID;

    if (!hideBanner) {
      intervalID = setInterval(() => {
        if (shouldShowBanner(COOKIE)) {
          setHideBanner(true);
        }
      }, 2000);
    } else {
      clearInterval(intervalID);
    }

    return () => clearInterval(intervalID);
  }, [hideBanner]);

  return <div>{!hideBanner && <Banner text={text} backgroundColour="purple" closeBanner={closeBanner} />}</div>;
};

export default WarningBanner;

export const shouldShowBanner = (cookieName): boolean => {
  return document.cookie.includes(cookieName);
};
